(function () {
  const SUFFIX = window.__klaviyoPriceDropSuffix || 'en-US';
  const LOCALE = window.__klaviyoPriceDropLocale || '';
  const EVENT_VIEWED = 'Viewed Product (Price Drop)';
  const EVENT_CHECKOUT = 'Started Checkout (Price Drop)';
  const EVENT_ORDERED = 'Ordered Product (Price Drop)';
  const CART_SUFFIX_KEY = 'klaviyo_price_drop_suffix';
  const CART_ITEMS_KEY = 'klaviyo_price_drop_line_items';

  function toProductId(productId, variantId) {
    if (!productId || !variantId) return null;
    return `${productId}_${variantId}_${SUFFIX}`;
  }

  function centsToPrice(cents) {
    if (cents == null || cents === '') return null;
    return Number(cents) / 100;
  }

  function track(eventName, payload) {
    const queue = window._learnq || [];
    window._learnq = queue;
    queue.push(['track', eventName, payload]);
  }

  function isColourOption(name) {
    return /colou?r|couleur|farbe|colore|kleur|cor|kolor|färg|farve|väri|szín/i.test(name || '');
  }

  function isSizeOption(name) {
    return /size|taille|größe|grosse|groesse|taglia|talla|maat|tamanho|st[øo]rrelse|storlek|rozmiar|méret|koko|pointure|schuh/i.test(
      name || '',
    );
  }

  function looksLikeSize(value) {
    if (!value || typeof value !== 'string') return false;
    const v = value.trim();
    return /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/i.test(v) ||
      /^\d{1,2}(\.\d)?$/.test(v) ||
      /^\d{1,2}\s*\/\s*\d{1,2}$/.test(v) ||
      /^(UK|EU|US)\s*\d+/i.test(v) ||
      /^\d{2,3}$/.test(v);
  }

  function parseVariantTitle(variantTitle) {
    if (!variantTitle || variantTitle === 'Default Title') {
      return { colour: '', size: '' };
    }

    const parts = variantTitle.split(' / ').map((part) => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      return {
        colour: parts[0],
        size: parts[parts.length - 1],
      };
    }

    if (parts.length === 1) {
      if (looksLikeSize(parts[0])) {
        return { colour: '', size: parts[0] };
      }
      return { colour: parts[0], size: '' };
    }

    return { colour: '', size: '' };
  }

  function parseVariantOptions(variantOptions, optionNames) {
    let colour = '';
    let size = '';
    if (!Array.isArray(variantOptions) || variantOptions.length === 0) {
      return { colour, size };
    }

    variantOptions.forEach((value, index) => {
      if (!value) return;
      const label = (optionNames && optionNames[index]) || '';
      if (!colour && isColourOption(label)) colour = value;
      else if (!size && isSizeOption(label)) size = value;
    });

    if (variantOptions.length >= 2) {
      if (!colour) colour = variantOptions[0];
      if (!size) size = variantOptions[variantOptions.length - 1];
    } else if (variantOptions.length === 1) {
      const value = variantOptions[0];
      if (!size && looksLikeSize(value)) {
        size = value;
      } else if (!colour) {
        colour = value;
      }
    }

    return { colour, size };
  }

  function parseOptions(variant, options) {
    let colour = '';
    let size = '';
    if (!variant || !Array.isArray(options)) return { colour, size };

    options.forEach((opt) => {
      const name = opt.name || '';
      const value = variant[`option${opt.position}`] || '';
      if (!colour && isColourOption(name)) {
        colour = value;
      } else if (!size && isSizeOption(name)) {
        size = value;
      }
    });

    const sortedOptions = [...options].sort((a, b) => a.position - b.position);
    const values = sortedOptions
      .map((opt) => variant[`option${opt.position}`] || '')
      .filter(Boolean);

    if (values.length >= 2) {
      if (!colour) colour = values[0];
      if (!size) size = values[values.length - 1];
    } else if (values.length === 1) {
      if (!size && looksLikeSize(values[0])) {
        size = values[0];
      } else if (!colour) {
        colour = values[0];
      }
    }

    return { colour, size };
  }

  function resolveColourSize({ colour, size, variantOptions, optionNames, variantTitle }) {
    let resolvedColour = colour || '';
    let resolvedSize = size || '';

    const fromOptions = parseVariantOptions(variantOptions, optionNames);
    if (!resolvedColour) resolvedColour = fromOptions.colour;
    if (!resolvedSize) resolvedSize = fromOptions.size;

    const fromTitle = parseVariantTitle(variantTitle);
    if (!resolvedColour) resolvedColour = fromTitle.colour;
    if (!resolvedSize) resolvedSize = fromTitle.size;

    return { colour: resolvedColour, size: resolvedSize };
  }

  function buildItemPayload(productId, variantId, itemPrice, compareAtPrice, productName, colour, size) {
    return {
      ProductID: toProductId(productId, variantId),
      ItemPrice: itemPrice,
      CompareAtPrice: compareAtPrice,
      ProductName: productName || '',
      Colour: colour || '',
      Size: size || '',
    };
  }

  function initViewedProduct(config) {
    if (!config || !config.productId || !Array.isArray(config.variants)) return;

    const trackView = (variant) => {
      if (!variant) return;
      const { colour, size } = parseOptions(variant, config.options);
      track(
        EVENT_VIEWED,
        buildItemPayload(
          config.productId,
          variant.id,
          centsToPrice(variant.price),
          centsToPrice(variant.compare_at_price),
          config.productName,
          colour,
          size,
        ),
      );
    };

    const initial =
      config.variants.find((variant) => variant.id === config.selectedVariantId) ||
      config.variants[0];
    trackView(initial);

    document.addEventListener('variantChangeEnd', () => {
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const variantId = input ? Number(input.value) : null;
      const variant = config.variants.find((v) => v.id === variantId);
      trackView(variant);
    });
  }

  function getCartItemMeta(variantId) {
    const map = window.__klaviyoPriceDropCartItems || {};
    return map[String(variantId)] || map[variantId] || {};
  }

  function mapCartLineItem(item) {
    const meta = getCartItemMeta(item.variant_id);
    const { colour, size } = resolveColourSize({
      colour: meta.Colour || '',
      size: meta.Size || '',
      variantOptions: item.variant_options,
      optionNames: meta.optionNames,
      variantTitle: item.variant_title,
    });

    const compareAt =
      meta.CompareAtPrice != null ? meta.CompareAtPrice : centsToPrice(item.original_price);

    return buildItemPayload(
      item.product_id,
      item.variant_id,
      centsToPrice(item.price),
      compareAt,
      item.product_title || item.title,
      colour,
      size,
    );
  }

  function buildCartLineItemsMeta(cartItems) {
    const meta = {};
    (cartItems || []).forEach((item) => {
      const payload = mapCartLineItem(item);
      meta[String(item.variant_id)] = {
        CompareAtPrice: payload.CompareAtPrice,
        Colour: payload.Colour,
        Size: payload.Size,
      };
    });
    return meta;
  }

  async function syncCartAttributes(cartItems) {
    if (!window.__klaviyoPriceDropSuffix) return;

    const items = cartItems || [];
    const attributes = {
      [CART_SUFFIX_KEY]: window.__klaviyoPriceDropSuffix,
      [CART_ITEMS_KEY]: JSON.stringify(buildCartLineItemsMeta(items)),
    };

    try {
      await fetch(`${window.location.origin}/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
    } catch (_) {}
  }

  async function refreshCartAttributes() {
    try {
      const response = await fetch(`${window.location.origin}/cart.js`);
      const cart = await response.json();
      await syncCartAttributes(cart.items || []);
    } catch (_) {}
  }

  function initCartAttributeSync() {
    refreshCartAttributes();
    document.addEventListener('cart-update', refreshCartAttributes);
  }

  function initStartedCheckout() {
    let tracked = false;

    const fire = async () => {
      if (tracked) return;
      tracked = true;

      try {
        const response = await fetch(`${window.location.origin}/cart.js`);
        const cart = await response.json();
        await syncCartAttributes(cart.items || []);
        const items = (cart.items || []).map(mapCartLineItem);
        track(EVENT_CHECKOUT, {
          items,
          $value: centsToPrice(cart.total_price) || 0,
          'Customer Locale': LOCALE,
        });
      } catch (_) {
        tracked = false;
      }
    };

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[name="checkout"]');
        if (button && !button.disabled) fire();
      },
      true,
    );
  }

  function parseCompositeProductId(value) {
    if (!value || typeof value !== 'string') return null;
    const parts = value.split('_');
    if (parts.length < 2) return null;
    return {
      productId: parts[0],
      variantId: parts[1],
    };
  }

  function normalizeOrderedItem(item) {
    const parsed = parseCompositeProductId(item.ProductID);
    const productId = item.product_id || parsed?.productId;
    const variantId = item.variant_id || item.VariantID || parsed?.variantId || item.id;

    let productID = item.ProductID;
    if (!productID || !String(productID).endsWith(`_${SUFFIX}`)) {
      productID = toProductId(productId, variantId);
    }

    const itemPrice =
      item.ItemPrice ??
      item.Price ??
      (item.price != null ? centsToPrice(item.price) : null);

    let compareAtPrice = item.CompareAtPrice;
    if (compareAtPrice == null && item.compare_at_price != null) {
      compareAtPrice = centsToPrice(item.compare_at_price);
    }

    return {
      ProductID: productID,
      ItemPrice: itemPrice,
      CompareAtPrice: compareAtPrice,
      ProductName: item.ProductName || item.product_name || item.title || item.name || '',
      Colour: item.Colour || item.colour || item.Color || item.color || '',
      Size: item.Size || item.size || '',
    };
  }

  function splitPlacedOrder(order) {
    const items = order.Items || order.items || [];
    items.forEach((item) => {
      const payload = normalizeOrderedItem(item);
      if (!payload.ProductID) return;
      track(EVENT_ORDERED, payload);
    });
  }

  function installTrackIntercept(queue) {
    if (!queue || queue.__priceDropIntercept) return;

    queue.__priceDropIntercept = true;
    const originalPush = queue.push.bind(queue);
    queue.push = function (...args) {
      const result = originalPush(...args);
      if (args[0] === 'track' && args[1] === 'Placed Order' && args[2]) {
        splitPlacedOrder(args[2]);
      }
      return result;
    };
  }

  function installPlacedOrderIntercept() {
    window._learnq = window._learnq || [];
    installTrackIntercept(window._learnq);

    const hookKlaviyoPush = () => {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        installTrackIntercept(window.klaviyo);
        return true;
      }
      return false;
    };

    if (!hookKlaviyoPush()) {
      let attempts = 0;
      const timer = window.setInterval(() => {
        if (hookKlaviyoPush() || ++attempts > 40) {
          window.clearInterval(timer);
        }
      }, 250);
    }
  }

  window.KlaviyoPriceDrop = {
    initViewedProduct,
    initStartedCheckout,
    installPlacedOrderIntercept,
    syncCartAttributes,
    refreshCartAttributes,
    toProductId,
  };

  installPlacedOrderIntercept();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCartAttributeSync();
      initStartedCheckout();
    });
  } else {
    initCartAttributeSync();
    initStartedCheckout();
  }

  const viewedConfig = window.__klaviyoPriceDropViewedConfig;
  if (viewedConfig) {
    initViewedProduct(viewedConfig);
  }
})();
